export default __webpack_public_path__ + "static/media/cl18.7ab99dcc.webp";